import React, { useEffect, useState } from 'react';
import { SplitterPaneProps } from '@progress/kendo-react-layout';
import cn from 'clsx';
import debounce from 'lodash/debounce';
import WidgetsSection from './sections/widget-section';
import CoreSplitter from '@components-clean/core/core-splitter';
import { IsPopOut } from '@components-clean/core/page-toolbar/page-toolbar';
import { CountrySelectorContextProvider } from '@contexts-clean/country-selector-context';
import ActionBar from '@pages-clean/central-monitoring/components/action-bar/action-bar';
import { ChartsView } from '@pages-clean/central-monitoring/controls-hub/sections/chart-view';
import { GridSection } from '@pages-clean/central-monitoring/controls-hub/sections/grid-section';
import { useWindowSize } from '@hooks/index';
import { SplitterOrientation } from '@utils/constants';
import { LoggedInPageProps } from '@config/routes/interfaces';
import './index.scss';

export const ControlsHub = ({ study, cm2Dataset: dataset }: LoggedInPageProps) => {
    const { width } = useWindowSize();

    const [alignmentValues, setAlignmentValues] = useState<SplitterPaneProps[]>(
        width > 1024 ? [{ size: '60%' }, {}] : [{ size: '70%' }, {}],
    );

    useEffect(() => {
        setAlignmentValues(width > 1024 ? [{ size: '60%' }, {}] : [{ size: '70%' }, {}]);
    }, [width]);

    const studyRef = study?.id as string;
    return (
        <CountrySelectorContextProvider studyRef={studyRef}>
            <div className={cn('controls-hub', { 'pop-out': IsPopOut() })}>
                <ActionBar countrySelector studyRef={studyRef} datasetId={dataset?.id as number} />
                <CoreSplitter
                    className="splitterHeight "
                    orientation={SplitterOrientation.vertical}
                    alignmentValues={alignmentValues}
                    onChange={(e) => {
                        debounce(() => {
                            setAlignmentValues(e.newState);
                        }, 300);
                    }}
                    data-testid="data-view-page-splitter"
                >
                    <div
                        data-testid="controls-hub-widgets-panels-pane"
                        className="k-h-full k-d-flex-col k-overflow-y-auto"
                    >
                        <WidgetsSection studyRef={studyRef} datasetId={dataset?.id as number} />
                        <ChartsView studyRef={studyRef} dataset={dataset!} />
                    </div>
                    <GridSection studyRef={studyRef} dataset={dataset!} />
                </CoreSplitter>
            </div>
        </CountrySelectorContextProvider>
    );
};
